var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kivh8968ya"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 216",
    style: {
      fill: "none"
    },
    d: "M0 0h44v44H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 139"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 138",
    style: {
      clipPath: "url(#kivh8968ya)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 49",
    d: "M1.012 10.787a2.814 2.814 0 0 1 1.94-2.051c1.577-.442 3.192-.744 4.788-1.118.669-.157 1.331-.347 2-.522a3.641 3.641 0 0 0 .5-.039c1.1-.237 2.2-.484 3.3-.724 1.774-.388 3.55-.772 5.323-1.162 1.606-.354 3.212-.709 4.815-1.076 1.066-.244 2.127-.51 3.19-.767l.869-.088c-.015.141-.018.286-.047.424-.413 1.994-.834 3.987-1.243 5.982-.194.944-.191.931-1.157 1.223-3.312 1-6.62 2.014-9.93 3.018-1.94.589-3.884 1.166-5.823 1.755-.787.239-1.581.462-2.348.755a1.251 1.251 0 0 0-.781 1.595 1.27 1.27 0 0 0 1.638.9c2.867-.852 5.729-1.724 8.591-2.6 2.577-.785 5.152-1.58 7.728-2.368.4-.121.8-.23 1.232-.355-.38 1.824-.74 3.58-1.121 5.332a.539.539 0 0 1-.31.3q-3.815 1.468-7.637 2.916c-1.95.742-3.9 1.475-5.849 2.227a1.367 1.367 0 0 0-.863 1.8 1.341 1.341 0 0 0 1.806.719l11.7-4.459a1.25 1.25 0 0 1 .355-.026 3.232 3.232 0 0 1-.008.325 5.972 5.972 0 0 0-.168 1.475c.176 1.253.445 2.494.7 3.735a.535.535 0 0 1-.335.71c-1.2.554-2.386 1.141-3.581 1.705-1.041.492-2.088.968-3.131 1.455-.888.415-1.781.822-2.659 1.259a1.346 1.346 0 0 0-.725 1.812 1.386 1.386 0 0 0 1.922.592c.28-.166.594-.272.889-.412l6.277-2.987c.625-.3 1.259-.576 1.919-.876.053.222.086.4.138.574.073.244.16.484.241.726l.113 1.029.089.066h.01c.981-.637 1.967-1.267 2.942-1.914.693-.46 1.372-.942 2.058-1.415a.883.883 0 0 0 .2-.071q2.34-1.544 4.676-3.092c.2-.346.4-.688.585-1.04q1.119-2.116 2.229-4.236c.324.712.635 1.43.976 2.134 1.007 2.078 2.025 4.151 3.039 6.225a3.218 3.218 0 0 1-.145.442 21.783 21.783 0 0 1-10.644 10.229 21.787 21.787 0 0 1-8.659 1.862 20.435 20.435 0 0 1-4.714-.507 20.777 20.777 0 0 1-6.046-2.346c-.537-.315-1.083-.615-1.624-.922-.038-.075-.082-.147-.115-.224-1.49-3.552-3.013-7.091-4.455-10.662-.63-1.56-1.108-3.183-1.633-4.784-.495-1.509-.959-3.027-1.439-4.545q-.228-.721-.458-1.441a3.888 3.888 0 0 0-.06-.463q-.568-2.274-1.15-4.545",
    transform: "translate(-.834 -2.595)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 50",
    d: "m329.541 16.961 4.169 2.173a2.5 2.5 0 0 1 1.039 1.333v.946l-1.8 3.514c-.311-.2-.611-.413-.934-.585-1.556-.828-3.121-1.641-4.678-2.468-.5-.264-.983-.553-1.473-.831a2.016 2.016 0 0 1 .106-.323c.475-.909.925-1.833 1.443-2.716a1.809 1.809 0 0 1 1.678-.981 2.647 2.647 0 0 0 .451-.062",
    transform: "translate(-291.045 -14.839)",
    style: {
      fill: "#f14881"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 51",
    d: "M72.894.348a3.668 3.668 0 0 1 3.7.315 3.1 3.1 0 0 1 1.161 1.921l.261.8-.441 1.007a1.238 1.238 0 0 0-1.295.9c-.14.438.082.765.188 1.134l-.626 1.207-2.832 5.457c-.532 1.023-1.079 2.038-1.6 3.064-.453.883-.886 1.776-1.327 2.664.026.509.064 1.017.077 1.527.036 1.448.062 2.9.092 4.344v.342l.065 4.552c-.081-.242-.168-.482-.241-.726-.052-.173-.085-.351-.138-.574-.66.3-1.293.58-1.919.876q-3.14 1.489-6.276 2.987c-.3.14-.609.246-.889.412a1.386 1.386 0 0 1-1.922-.593 1.346 1.346 0 0 1 .725-1.812c.878-.437 1.77-.844 2.659-1.259 1.043-.487 2.09-.964 3.131-1.455 1.2-.565 2.381-1.151 3.581-1.705a.535.535 0 0 0 .335-.71c-.256-1.241-.525-2.482-.7-3.735a5.971 5.971 0 0 1 .168-1.475 3.2 3.2 0 0 0 .008-.325 1.254 1.254 0 0 0-.355.026q-5.85 2.225-11.7 4.459a1.341 1.341 0 0 1-1.806-.719 1.367 1.367 0 0 1 .863-1.8c1.946-.752 3.9-1.485 5.849-2.227q3.82-1.453 7.637-2.916a.539.539 0 0 0 .31-.3c.38-1.752.741-3.508 1.121-5.332-.436.125-.836.234-1.232.355-2.576.788-5.151 1.583-7.728 2.368-2.862.871-5.724 1.743-8.591 2.6a1.27 1.27 0 0 1-1.638-.9 1.252 1.252 0 0 1 .781-1.595c.767-.293 1.561-.516 2.348-.755 1.94-.589 3.883-1.166 5.823-1.755 3.311-1 6.618-2.018 9.93-3.018.966-.292.963-.279 1.157-1.223.41-2 .83-3.988 1.244-5.982.029-.139.032-.283.047-.424",
    transform: "translate(-45.992 .296)",
    style: {
      fill: "#d5d4e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 52",
    d: "M120.823 254.888c-.277.732-.512 1.484-.839 2.192a21.362 21.362 0 0 1-5.112 6.947A21.635 21.635 0 0 1 98.92 269.6a20.309 20.309 0 0 1-7.491-1.893c-.279-.131-.549-.285-.823-.428l-.083-.07v.005c-.263-.566-.523-1.133-.789-1.7q-.84-1.779-1.686-3.555c.542.307 1.087.607 1.624.922a20.776 20.776 0 0 0 6.046 2.346 20.439 20.439 0 0 0 4.714.507 21.784 21.784 0 0 0 8.659-1.862 21.782 21.782 0 0 0 10.639-10.23 3.231 3.231 0 0 0 .145-.442l.944 1.684",
    transform: "translate(-78.644 -225.644)",
    style: {
      fill: "#d5d4e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 53",
    d: "m9.408 155.132 1.686 3.556c.266.564.526 1.131.789 1.7-.947-.567-1.933-1.077-2.834-1.711a20.854 20.854 0 0 1-5.977-6.544 21.8 21.8 0 0 1-2.715-7.25 22.231 22.231 0 0 1-.312-5.4 19.869 19.869 0 0 1 1.25-5.915.412.412 0 0 0 .014-.084l.458 1.44c.478 1.514.943 3.032 1.437 4.54.525 1.6 1 3.224 1.633 4.784 1.443 3.571 2.965 7.11 4.456 10.662.032.077.076.149.115.224",
    transform: "translate(0 -118.813)",
    style: {
      fill: "#ffcc4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 54",
    d: "m353.306 127.283-.944-1.684c-1.014-2.075-2.033-4.147-3.039-6.225-.341-.7-.651-1.422-.976-2.134a2.135 2.135 0 0 1 .1-.278q1.743-3.382 3.491-6.762l.21.016c.42 1.042.9 2.064 1.243 3.133a21.156 21.156 0 0 1 .819 3.411 27.807 27.807 0 0 1 .265 3.994 18.938 18.938 0 0 1-.8 5.362c-.117.391-.245.779-.367 1.168",
    transform: "translate(-311.127 -98.038)",
    style: {
      fill: "#ffcc4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 55",
    d: "m298.638 99.575-3.491 6.762a2.142 2.142 0 0 0-.1.278l-2.229 4.236c-.186.351-.389.693-.585 1.04a2.894 2.894 0 0 0-2.13-.163 9.787 9.787 0 0 0-1.432.849 2.456 2.456 0 0 1 .13-.4c.416-.8.848-1.586 1.261-2.385 1.213-2.348 2.417-4.7 3.63-7.049.387-.748.8-1.483 1.185-2.231s.739-1.479 1.107-2.22c.151.074.3.149.454.222l2.2 1.06",
    transform: "translate(-257.828 -87.413)",
    style: {
      fill: "#72baed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 56",
    d: "M83.321 4.234A21.1 21.1 0 0 1 92.268.381c.856-.148 1.731-.2 2.6-.259a14.669 14.669 0 0 1 2.157-.07c1.075.082 2.143.266 3.214.405.07.009.142.006.213.009-1.063.256-2.124.523-3.19.767-1.6.367-3.209.722-4.815 1.076-1.774.391-3.549.774-5.324 1.162-1.1.241-2.2.488-3.3.724a3.661 3.661 0 0 1-.5.039",
    transform: "translate(-74.418 .267)",
    style: {
      fill: "#ffcc4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 57",
    d: "M250.635 200.1a9.776 9.776 0 0 1 1.432-.849 2.894 2.894 0 0 1 2.13.163q-2.337 1.547-4.676 3.092a.877.877 0 0 1-.2.071 20.828 20.828 0 0 0-1.673-1.63 9.857 9.857 0 0 0-1.568-.849c.019-.068.036-.137.057-.205l1.061-3.417a2.267 2.267 0 0 1 1.9.3 2.952 2.952 0 0 1 1.39 3.3l-.151.351.1.045.19-.378z",
    transform: "translate(-219.791 -174.935)",
    style: {
      fill: "#d5d4e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 58",
    d: "M231.378 230.922a9.867 9.867 0 0 1 1.568.849 20.82 20.82 0 0 1 1.673 1.63c-.685.472-1.364.955-2.058 1.414-.975.647-1.961 1.277-2.942 1.914a2.769 2.769 0 0 1 .066-.457c.505-1.6 1.02-3.2 1.524-4.8a3.717 3.717 0 0 0 .088-.542.221.221 0 0 1 .081-.009",
    transform: "translate(-205.084 -205.761)",
    style: {
      fill: "#464b5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59",
    d: "M228.959 229.473a3.715 3.715 0 0 1-.089.542c-.5 1.6-1.019 3.2-1.524 4.8a2.772 2.772 0 0 0-.066.457h-.01l-.089-.066-.116-1.027-.065-4.552v-.341l1.955.186",
    transform: "translate(-202.746 -204.302)",
    style: {
      fill: "#33384a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 60",
    d: "m228.7 284.272.089.066-.089-.066",
    transform: "translate(-204.26 -253.366)",
    style: {
      fill: "#464b5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 61",
    d: "m317.368 59.547-2.2-1.06c-.152-.073-.3-.148-.454-.222-.536-.288-1.073-.574-1.608-.863q-1.585-.857-3.169-1.716l-.093-.085-.011.012c-.041-.134-.079-.269-.123-.4a1.239 1.239 0 0 1 .673-1.558l.5-.217.494.155c.491.278.975.567 1.473.831 1.557.827 3.122 1.639 4.678 2.468.323.172.623.389.934.585a1.331 1.331 0 0 1-.883 2.089l-.211-.016",
    transform: "translate(-276.558 -47.385)",
    style: {
      fill: "#d5d3e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 62",
    d: "m298.843 7.769-.494-.155c-.677-.368-1.351-.744-2.035-1.1a6.092 6.092 0 0 0-.7-.266l.441-1.007.321-.61c.243-.464.487-.927.728-1.392a2.038 2.038 0 0 1 2.841-.911c.882.4 1.721.9 2.579 1.358a2.658 2.658 0 0 1-.451.062 1.808 1.808 0 0 0-1.678.981c-.518.884-.969 1.807-1.443 2.716a2.006 2.006 0 0 0-.106.323",
    transform: "translate(-264.026 -1.565)",
    style: {
      fill: "#cf3168"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 63",
    d: "m297.872 24.2-.321.61-.262-.8.583.186",
    transform: "translate(-265.524 -21.129)",
    style: {
      fill: "#feca54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 64",
    d: "M225.446 72.07c.442-.888.875-1.781 1.327-2.664.526-1.026 1.072-2.041 1.6-3.064q1.419-2.727 2.832-5.457l.626-1.207c.3.186.6.38.9.555.552.314 1.11.617 1.666.925a1.6 1.6 0 0 0-.149.2q-2.062 3.974-4.12 7.949c-.8 1.546-1.617 3.085-2.413 4.635-.219.427-.386.88-.578 1.322l-.18.009c0-.285.01-.57.006-.854a2.646 2.646 0 0 0-1.529-2.351",
    transform: "translate(-201.358 -52.956)",
    style: {
      fill: "#2277c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 65",
    d: "M225.446 174.765a2.646 2.646 0 0 1 1.529 2.351c0 .285 0 .569-.006.854l.18-.009a2.953 2.953 0 0 1 1.622-.772l-1.061 3.417c-.021.068-.038.137-.057.205a.223.223 0 0 0-.081.009l-1.955-.186c-.03-1.448-.056-2.9-.092-4.344-.013-.509-.05-1.018-.077-1.527",
    transform: "translate(-201.358 -155.651)",
    style: {
      fill: "#cacbd3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 66",
    d: "M285.876 44.155c-.556-.308-1.114-.61-1.666-.925-.307-.175-.6-.369-.9-.555-.106-.369-.328-.7-.188-1.134a1.238 1.238 0 0 1 1.295-.9 6.073 6.073 0 0 1 .7.266c.684.356 1.357.732 2.035 1.1l-.5.217a1.239 1.239 0 0 0-.673 1.558c.044.133.082.268.123.4l-.228-.025",
    transform: "translate(-252.827 -35.954)",
    style: {
      fill: "#cacad3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 67",
    d: "m248.627 73.417.228.025.011-.011.093.085 3.169 1.716c.535.289 1.072.576 1.608.863-.368.74-.728 1.485-1.107 2.22s-.8 1.483-1.185 2.231c-1.213 2.348-2.417 4.7-3.63 7.049-.413.8-.845 1.588-1.261 2.385a2.463 2.463 0 0 0-.13.4h-.008l-.134-.018a2.952 2.952 0 0 0-1.39-3.3 2.267 2.267 0 0 0-1.9-.3 2.953 2.953 0 0 0-1.622.772c.191-.441.359-.895.578-1.322.795-1.55 1.61-3.089 2.413-4.635q2.062-3.974 4.12-7.949a1.6 1.6 0 0 1 .149-.2",
    transform: "translate(-215.578 -65.216)",
    style: {
      fill: "#55ace5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 68",
    d: "m286.082 230.784.134.018-.19.378-.1-.045.151-.351",
    transform: "translate(-255.38 -205.638)",
    style: {
      fill: "#72baed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 69",
    d: "m311.632 73.63-.093-.085.093.085",
    transform: "translate(-278.252 -65.33)",
    style: {
      fill: "#cacad3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 70",
    d: "m239.879 204.446-.18.009.18-.009",
    transform: "translate(-214.088 -182.136)",
    style: {
      fill: "#55ace5"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.81d809965dcd29537b76e13393b422ea.svg";
export { ForwardRef as ReactComponent };